module.exports = __webpack_public_path__ + "static/media/cert4.b2787e92.png";